module.exports = __webpack_public_path__ + "static/media/Jokerman.eec0608f.ttf";